export default __webpack_public_path__ + "static/Barnes-and-noble-booksellers-logo-287dcc4d2a9505292806bbdfc8250e92.png";